import React, { FC, JSX, PropsWithChildren, Ref, RefObject } from 'react';
import { Button, Col, Popover, Row } from 'reactstrap';
import LoadingOverlay from '../../UI/LoadingOverlay/LoadingOverlay';
import Keys from '../../../../_Translations/generated/date-range-input.en.t.json.keys';
import fallback from '../../../../_Translations/generated/date-range-input.en.t.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import useTranslation from '../../../Hooks/useTranslation';
import { DateRangeInputProps } from './DateRangeInputProps';

const DateRangeInputPopover: FC<
  PropsWithChildren<
    Pick<
      DateRangeInputProps,
      'popoverTargetRef' | 'popoverRef' | 'CustomHeader' | 'withColorCodedAvailability' | 'onSubmit'
    > & {
      ref?: Ref<HTMLDivElement>;
      containerRef: Ref<HTMLDivElement>;
      popoverTargetRef: RefObject<HTMLElement>;
      popoverOpen: boolean;
      togglePopover: () => void;
      externalPopoverRef?: RefObject<HTMLDivElement>;
      isLoading: boolean;
      submit: () => void;
    }
  >
> = ({
  ref,
  containerRef,
  children,
  popoverRef,
  externalPopoverRef,
  popoverTargetRef,
  withColorCodedAvailability,
  CustomHeader,
  popoverOpen,
  togglePopover,
  isLoading,
  onSubmit,
  submit
}): JSX.Element => {
  const { t } = useTranslation('date-range-input', fallback, Keys);

  return (
    <Popover
      className="iso__date-range__popover"
      container={(ref as RefObject<HTMLDivElement>) || containerRef}
      target={popoverTargetRef}
      isOpen={popoverOpen}
      toggle={togglePopover}
      placement="bottom-start"
    >
      <div ref={externalPopoverRef || popoverRef}>
        <LoadingOverlay isLoading={isLoading}>
          {CustomHeader || <></>}
          {children}
          {withColorCodedAvailability && (
            <Row className="my-2 justify-content-end no-gutters">
              <Col className="col-12 col-md-auto iso__date-range__offer-option px-2">
                <span className="iso__date-range__offer-option-label">{t(Keys.offer)}</span>
              </Col>
              <Col className="col-12 col-md-auto iso__date-range__offer-option px-2">
                <span className="iso__date-range__busy-option-label">{t(Keys.busy)}</span>
              </Col>
              <Col className="col-12 col-md-auto iso__date-range__offer-option px-2">
                <span className="iso__date-range__available-option-label">{t(Keys.available)}</span>
              </Col>
            </Row>
          )}
          {!!onSubmit && (
            <div className="iso__date-range__submit__container">
              <Button className="iso__date-range__submit w-100" color="primary" onClick={submit}>
                <span>{t(Keys.submit)}</span>
                <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
              </Button>
            </div>
          )}
        </LoadingOverlay>
      </div>
    </Popover>
  );
};

export default DateRangeInputPopover;
